const convertWebappStringToLatLngObject = (str) => {
  const result = str.split(', ');
  return {
    lat: Number.parseFloat(result[0]),
    lng: Number.parseFloat(result[1]),
  };
};

export default convertWebappStringToLatLngObject;
